import Icon from "./IconBase.js";

const DeleteIcon = (props) => {
  return (
    <Icon width="24" height="24" viewBox="0 0 24 24" {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.3245 9.46826C19.3245 9.46826 18.7815 16.2033 18.4665 19.0403C18.3165 20.3953 17.4795 21.1893 16.1085 21.2143C13.4995 21.2613 10.8875 21.2643 8.27955 21.2093C6.96055 21.1823 6.13755 20.3783 5.99055 19.0473C5.67354 16.1853 5.13354 9.46826 5.13354 9.46826"
          stroke="#DC2804"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.708 6.23975H3.75"
          stroke="#DC2804"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973"
          stroke="#DC2804"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};

export default DeleteIcon;
